import { useQuery } from "@tanstack/react-query"
import { sdk } from "@/api/sdk"
import { type MarketingWidgetType } from "@/generated/graphql"

// This hook fetches the latest marketing widget data
export const useLatestMarketingWidget = () => {
  return useQuery({
    queryKey: ["marketingWidget"],
    queryFn: async () => {
      try {
        const response = await sdk.GetLatestMarketingWidget()
        if (!response.marketingWidget) {
          console.info("null marketingWidget")
        }
        // console.log(`****RESPONSE-> ${JSON.stringify(response)}`)
        return response.marketingWidget as MarketingWidgetType
      } catch (err) {
        console.error("Error fetching marketing widget data:", err)
        throw err
      }
    },
  })
}
